<template>
  <fragment>
    <Layout background-color="#e3e9ea" hide-logout="true" :title="'Home'"
            active="home">
      <template v-slot:main-btn v-if="!loading && reportData.report">
        <div class="level-right">
          <router-link :to="{'name': 'calculator'}"
                       class="button is-primary">
            New Valuation
          </router-link>
        </div>
      </template>
<!-- -->
      <div class="columns"  v-if="!loading && !reportData.report">

        <div class="column">
          <img src="../../../images/report_sample.jpg"  style="float: left; width: 218px; margin: 25px 25px 15px 15px; border: 1px solid #ccc; border-radius: 5px;" alt="">
          <div class="blocks-white-container">
            <h1>
              Start a new valuation
            </h1>
            <div style="font-size: 16px">

              Start filling the questionnaire to describe your startup and get a detailed valuation using four methods,
              along with industry and country statistics and a <a href="https://startupfalcon.com/StartupFalconInc-20_02_2021.pdf" target="_blank">downloadable report (example)</a>.

            </div>
            <div class="sep-32"></div>
            <!-- <ul>
              <li>Your startup worth in $</li>
              <li>
                Downloadable valuation PDF report
              <li>Valuation in four methods</li>
              <li>Valuation breakdown</li>
              <li>Benchmarking and statistics</li>
            </ul> -->
            <div>
              <router-link :to="{'name': 'calculator'}"
                           class="button is-primary is-medium">
              New Valuation
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <!-- Report First Part -->
      <div class="columns" v-if="isStartup && !loading && reportData.report ">
        <div class="column is-one-third">
          <div class="blocks-white-container">
            <router-link :to="{'name':'startup-profile'}">
              <i class="fas fa-pen"></i>
              Edit Profile
            </router-link>
            <div class="sep-32"></div>
            <div class="block2-logo" :style=" profile.logo? {
              backgroundImage: `url(${profile.logo})`
            }: null"></div>
            <div class="sep-50"></div>
            <div class="block2-detailed-title">
              {{ profile.name }}
            </div>
            <div class="sep-40"></div>
            <div class="block2-item">
              <div class="block2-item-subtitle">
                Contact Name
              </div>
              <div class="block2-item-title">
                {{ profile.contact_name || '--' }}
              </div>
            </div>
            <div class="sep-16"></div>
            <div class="block2-item">
              <div class="block2-item-subtitle">
                Contact Email
              </div>
              <div class="block2-item-title">
                {{ profile.contact_email || '--' }}
              </div>
            </div>
            <div class="sep-16"></div>
            <div class="block2-item">
              <div class="block2-item-subtitle">
                Role
              </div>
              <div class="block2-item-title">
                {{ profile.title || '--' }}
              </div>
            </div>
            <div class="sep-16"></div>
            <div class="block2-item noborder">
              <div class="block2-item-subtitle">
                Latest Valuation Date
              </div>
              <div class="block2-item-title">
                <span v-if="reportData.report">
                   {{ reportData.valuation_date |  moment("YYYY-MM-DD") }}
                </span>
                <span v-if="!reportData.report">
                   --
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="column">

          <!-- Row1 -->
          <div class="columns">
            <div class="column">
              <div class="block1-number">
                <div class="block1-number-icon"></div>
                <div class="block1-number-content">
                  <div class="block1-number-label">
                    Pre-Money Valuation
                  </div>
                  <div class="block1-number-value">
                    <strong v-if="reportData.report">
                      {{ reportData.report.avg_valuation|formatDollarsNoZeros }}
                    </strong>
                    <!--<strong v-if="!reportData.report || reportData.report.status !== 'unlocked'">
                      {{ reportData.report.avg_valuation|formatDollarsNoZeros }}
                      <upgrade-action redirect-to="new-valuation">
                        <router-link style="font-size: 12px"  :to="{'name': 'calculator'}">
                          Unlock
                        </router-link>
                      </upgrade-action>
                    </strong> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="block1-action">
                <div class="block1-action-icon"></div>
                <div class="block1-action-label">
                  PDF Report
                </div>
                <div class="block1-action-btn">
                  <span v-if="!reportData.report">
                    --
                  </span>
                  <span v-if="reportData.report">
                    <upgrade-action v-if="reportData.report.status !== 'unlocked'">
                      <button to="#" class="button">
                        Download
                      </button>
                    </upgrade-action>
                    <button @click="downloadReport(reportData.report.id)" v-if="reportData.report.status === 'unlocked'"
                            class="button"
                            :class="{'is-loading': !reportData.is_report_ready}">
                      Download
                    </button>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!-- // Row1 -->

          <div class="columns">
            <div class="column">
              <div class="blocks-white-container min-height-startup">
                <div class="columns block2-detailed">
                  <div class="column is-4 ">
                    <div class="block2-item">
                      <div class="block2-item-subtitle">
                        Startup Name
                      </div>
                      <div class="block2-item-title">
                        {{ profile.name }}
                      </div>
                    </div>
                    <div class="sep-16"></div>
                    <div class="block2-item">
                      <div class="block2-item-subtitle">
                        Stage
                      </div>
                      <div class="block2-item-title">
                        {{ profile.stage && ProfileAPI.STARTUP_STAGE[profile.stage] || '--' }}
                      </div>
                    </div>
                  </div>
                  <div class="column is-4">
                    <div class="block2-item">
                      <div class="block2-item-subtitle">
                        Website
                      </div>
                      <div class="block2-item-title">
                        {{ profile.website || '--' }}
                      </div>
                    </div>
                    <div class="sep-16"></div>
                    <div class="block2-item">
                      <div class="block2-item-subtitle">
                        Country
                      </div>
                      <div class="block2-item-title">
                        {{ profile.country && profile.country.name || '--' }}
                      </div>
                    </div>
                  </div>
                  <div class="column is-4">
                    <div class="block2-item">
                      <div class="block2-item-subtitle">
                        Company Established
                      </div>
                      <div class="block2-item-title">
                        {{ profile.est_year || '--' }}
                      </div>
                    </div>
                    <div class="sep-16"></div>
                    <div class="block2-item">
                      <div class="block2-item-subtitle">
                        Industry
                      </div>
                      <div class="block2-item-title">
                        {{ profile.industry && profile.industry.name || '--' }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="block2-detailed ">
                  <div class="block2-item force-border">
                    <div class="block2-item-subtitle">
                      Startup Pitch
                    </div>
                    <div>
                      {{ profile.pitch || '--' }}
                    </div>
                  </div>
                </div>
                <div class="sep-16"></div>
                <div class="block2-detailed">
                  <div class="block2-item noborder">
                    <div class="block2-item-subtitle">
                      Startup Summary
                    </div>
                    <div>
                      {{ profile.summary || '--' }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="columns" v-if="!isStartup && !loading && reportData.report">
        <div class="column" v-if="loading">
          Loading..
        </div>

        <div class="column" v-if="!loading">
          <div class="columns">
            <div class="column is-4">
              <div class="blocks-white-container min-height">
                <router-link :to="{'name':'investor-profile'}">
                  <i class="fas fa-pen"></i>
                  Edit Profile
                </router-link>
                <div class="sep-32"></div>
                <div class="block2-logo" :style=" profile.logo? {
                  backgroundImage: `url(${profile.logo})`
                }: ''"></div>
                <div class="sep-50"></div>
                <div class="block2-item">
                  <div class="block2-item-subtitle">
                    Contact Name
                  </div>
                  <div class="block2-item-title">
                    {{ profile.contact_name }}
                  </div>
                </div>
                <div class="sep-16"></div>
                <div class="block2-item">
                  <div class="block2-item-subtitle">
                    Contact Email
                  </div>
                  <div class="block2-item-title">
                    {{ profile.contact_email }}
                  </div>
                </div>
                <div class="sep-16"></div>
                <div class="block2-item">
                  <div class="block2-item-subtitle">
                    Role
                  </div>
                  <div class="block2-item-title ">
                    {{ profile.title }}
                  </div>
                </div>
                <div class="sep-16"></div>
                <div class="block2-item noborder">
                  <div class="block2-item-subtitle">
                    Latest Valuation Date
                  </div>
                  <div class="block2-item-title">
                    <span v-if="reportData.report">{{ reportData.valuation_date |  moment("YYYY-MM-DD") }}</span>
                    <span v-if="!reportData.report">--</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-8">

              <div class="blocks-white-container min-height">
                <h4 class="is-light">
                  My Investor Profile
                </h4>
                <div class="sep-32"></div>
                <div class="columns">
                  <div class="column is-4">
                    <div class="block2-item">
                      <div class="block2-item-subtitle">
                        Contact Name
                      </div>
                      <div class="block2-item-title">
                        {{ profile.contact_name }}
                      </div>
                    </div>
                    <div class="sep-16"></div>
                    <div class="block2-item">
                      <div class="block2-item-subtitle">
                        Investment Stage
                      </div>
                      <div class="block2-item-title">
                        {{ profile.stage && ProfileAPI.INVESTOR_STAGE[profile.stage] || '--' }}
                      </div>
                    </div>
                    <div class="sep-16"></div>
                    <div class="block2-item">
                      <div class="block2-item-subtitle">
                        Count of Startups
                      </div>
                      <div class="block2-item-title" v-if="statistics.startups_count">
                        {{ statistics.startups_count }}
                      </div>
                      <div class="block2-item-title" v-if="!statistics.startups_count">
                        --
                      </div>
                    </div>

                    <div class="sep-16"></div>
                    <div class="block2-item">
                      <div class="block2-item-subtitle">
                        Min Valuation
                      </div>
                      <div class="block2-item-title">
                        <div class="block2-item-title" v-if="statistics.min_valuation">
                          {{ statistics.min_valuation|formatDollarsNoZeros }}
                        </div>
                        <div class="block2-item-title" v-if="!statistics.min_valuation">
                          --
                        </div>
                      </div>
                    </div>

                    <div class="sep-16"></div>
                    <div class="block2-item noborder">
                      <div class="block2-item-subtitle">
                        Portfolio Size
                      </div>
                      <div class="block2-item-title">
                        {{ ProfileAPI.PORTFOLIO_SIZE[profile.portfolio_size] }}
                      </div>
                    </div>
                  </div>
                  <div class="column is-4">
                    <div class="block2-item">
                      <div class="block2-item-subtitle">
                        Website
                      </div>
                      <div class="block2-item-title">
                        {{ profile.website }}
                      </div>
                    </div>
                    <div class="sep-16"></div>
                    <div class="block2-item">
                      <div class="block2-item-subtitle">
                        Country
                      </div>
                      <div class="block2-item-title">
                        {{ profile.country.name }}
                      </div>
                    </div>
                    <div class="sep-16"></div>
                    <div class="block2-item">
                      <div class="block2-item-subtitle">
                        Functions
                      </div>
                      <div class="block2-item-title">
                        {{ ProfileAPI.INVESTOR_FUNCTIONS[profile.providing_functions] }}
                      </div>
                    </div>
                    <div class="sep-16"></div>
                    <div class="block2-item noborder">
                      <div class="block2-item-subtitle">
                        Max Valuation
                      </div>
                      <div class="block2-item-title" v-if="statistics.max_valuation">
                        {{ statistics.max_valuation|formatDollarsNoZeros }}
                      </div>
                      <div class="block2-item-title" v-if="!statistics.max_valuation">
                        --
                      </div>
                    </div>
                  </div>
                  <div class="column is-4">
                    <div class="block2-item">
                      <div class="block2-item-subtitle">
                        Company Established
                      </div>
                      <div class="block2-item-title">
                        {{ profile.est_year }}
                      </div>
                    </div>
                    <div class="sep-16"></div>
                    <div class="block2-item">
                      <div class="block2-item-subtitle">
                        Type of Enterprise
                      </div>
                      <div class="block2-item-title">
                        {{ ProfileAPI.ENTERPRISE_STAGE [profile.enterprise_type] }}
                      </div>
                    </div>
                    <div class="sep-16"></div>
                    <div class="block2-item">
                      <div class="block2-item-subtitle">
                        Investment Range
                      </div>
                      <div class="block2-item-title">
                        {{ ProfileAPI.INVESTMENT_RANGES[profile.investment_ranges] }}
                      </div>
                    </div>
                    <div class="sep-16"></div>
                    <div class="block2-item noborder">
                      <div class="block2-item-subtitle">
                        Average Valuation
                      </div>
                      <div class="block2-item-title">
                        <div class="block2-item-title" v-if="statistics.avg_valuation">
                          {{ statistics.avg_valuation|formatDollarsNoZeros }}
                        </div>
                        <div class="block2-item-title" v-if="!statistics.avg_valuation">
                          --
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="columns" v-if="!isStartup && !loading && reportData.report">
        <div class="column">
          <div class="blocks-white-container">
            <h4>
              Top 3 Startups
            </h4>

            <table class="table falcon-table">
              <thead>
              <tr>
                <th>
                  Date
                </th>
                <th>
                  Name
                </th>
                <th>
                  Pre-Money Valuation
                </th>
                <th>
                  Capital Needed
                </th>
                <th>
                  Investor %
                </th>
                <th></th>
              </tr>
              </thead>

              <tbody>
              <tr v-if="statistics.top_startups.length === 0">
                <td colspan="6">
                  No valuations yet.
                </td>
              </tr>
              <!--v-for="report in fullReports"-->
              <tr v-for="report in statistics.top_startups">
                <td>
                  {{ report.created | moment("YYYY-MM-DD") }}
                </td>
                <td>
                  {{ report.startup_name }}
                </td>
                <td>
                  {{ report.avg_valuation|formatDollarsNoZeros }}
                </td>
                <td>
                  {{ report.useoffund.requested_fund|formatDollarsNoZeros }}
                </td>
                <td>
                  {{ report.useoffund.in_return_for }}%
                </td>
                <td>
                  <b-dropdown class="falcon-dropdown">
                    <div class="button more-button" slot="trigger">
                      <img height="16px" width="16px" src="../../../images/icons/more.svg" alt="">
                    </div>

                    <b-dropdown-item @click="goToResults(report)" aria-role="listitem">
                      <img src="../../../images/icons/results.svg" alt="">
                      View Results
                    </b-dropdown-item>
                    <b-dropdown-item :has-link="false" v-if="report.status !== 'unlocked'" aria-role="listitem">
                      <upgrade-action :block="true">
                        <div>
                          <img src="../../../images/icons/download.svg" alt="">
                          Download PDF
                        </div>
                      </upgrade-action>

                    </b-dropdown-item>
                    <b-dropdown-item v-if="report.is_report_ready && report.status === 'unlocked'"
                                     @click="downloadReport(report.id)" aria-role="listitem">
                      <img src="../../../images/icons/download.svg" alt="">
                      Download PDF
                    </b-dropdown-item>
                    <b-dropdown-item :disabled="true" v-if="!report.is_report_ready && report.status === 'unlocked'"
                                     aria-role="listitem">
                      <i class="fas fa-circle-notch fa-spin"></i>
                      PDF in processing
                    </b-dropdown-item>
                  </b-dropdown>
                </td>
              </tr>

              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Layout>
  </fragment>
</template>

<script>
import {range} from "@/shared/utils";
import LeftInfoCol from "../components/LeftInfoCol";
import FundUseGraph from "@/shared/components/charts/FundUseGraph";
import InvestmentPercentageGraph from "@/shared/components/charts/InvestmentPercentageGraph";
import ShareholdersGraph from "@/shared/components/charts/ShareholdersGraph";
import IndustryRangeGraph from "@/shared/components/charts/IndustryRangeGraph";
import CountryRangeGraph from "@/shared/components/charts/CountryRangeGraph";
import FourmethodsValuationGraph from "@/shared/components/charts/FourmethodsValuationGraph";
import RiskstepupGraph from "@/shared/components/charts/RiskGraph";
import ScorecardGraph from "@/shared/components/charts/ScorecardGraph";
import ChecklistGraph from "@/shared/components/charts/ChecklistGraph";
import Layout from "@/shared/components/Layout";
import WorldRangeGraph from "@/shared/components/charts/WorldRangeGraph";
import StageGraph from "@/shared/components/charts/StageGraph";
import {mapGetters} from "vuex";
import UpgradeAction from "@/shared/components/UpgradeAction";
import {ReportAPI} from "@/apis/ReportAPI";
import {ProfileAPI} from "@/apis/ProfileAPI";
import CalculatorMixin from "@/modules/calculator/mixins";

export default {
  name: 'home',
  components: {
    Layout,
    LeftInfoCol,
    ChecklistGraph,
    StageGraph,
    ScorecardGraph,
    RiskstepupGraph,
    FourmethodsValuationGraph,
    CountryRangeGraph,
    WorldRangeGraph,
    IndustryRangeGraph,
    ShareholdersGraph,
    InvestmentPercentageGraph,
    FundUseGraph,
    UpgradeAction
  },
  mixins: [CalculatorMixin],
  data() {
    return {
      scrollTop: 0,
      activeStep: 0,
      loading: true,
      countryId: '',
      industryId: '',
      showResults: false,
      answers: {},
      reportData: {},
      profile: {},
      results: {},
      completedSteps: {},
      ProfileAPI: ProfileAPI,
      year_range: (range(1980, new Date().getFullYear())).reverse()
    }
  },
  methods: {
    goToResults(report) {
      if (report.is_light) {
        this.$router.push({'name': 'report_light', 'params': {'id': report.id}});
      } else {
        this.$router.push({'name': 'report', 'params': {'id': report.id}});
      }
    }
  },
  async mounted() {
    this.loading = true;
    let homeReportId = await ReportAPI.getHomeReport();
    if (homeReportId.id) {
      this.reportData = await ReportAPI.getReport(homeReportId.id);
    }
    if (this.isStartup) {
      this.profile = await ProfileAPI.getStartupProfile();
    } else {
      this.profile = await ProfileAPI.getInvestorProfile();
      this.statistics = await ReportAPI.statistics();
    }

    this.loading = false;
    SFAnalytics.track('Dashboard Home Page Viewed');
  },
  watch: {},
  computed: {
    ...mapGetters('account', [
      'hasCredits',
    ]),
    ...mapGetters(['userInfo', 'isStartup', 'isInvestor'])
  }
}
</script>

<style scoped lang="scss">
.white-block {
  background-color: #fff;
}

.min-height {
  min-height: 655px;
}

.min-height-startup {
  min-height: 585px;
}
</style>
